import { render, staticRenderFns } from "./OrdenCompraShow.vue?vue&type=template&id=8b6afff4&scoped=true&"
import script from "./OrdenCompraShow.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraShow.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraShow.vue?vue&type=style&index=0&id=8b6afff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6afff4",
  null
  
)

export default component.exports